/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useWeb3Context } from "./hooks/web3Context";
import { Box } from "@mui/material";
import styled from "styled-components";
import TopBar from "./components/TopBar/TopBar";

import "./App.css";
import "./web3modal.css";
import "react-multi-carousel/lib/styles.css";
import "aos/dist/aos.css";

import Notification from "./components/Notification";
import useProjectInfo from "./hooks/useProjectinfo";
import { CustomizeWeb3Modal } from "./utils/CustomWeb3modal";
import Inventory from "./pages/Inventory";
import Footer from "./components/Footer";
import MintNFT from "./pages/MintNFT";
import Home from "./pages/Home";



function App() {
  const { connect, hasCachedProvider, closeModal } = useWeb3Context();
  const { notification, setNotification } = useProjectInfo();

  useEffect(() => {
    if (hasCachedProvider()) {
      // then user DOES have a wallet
      connect().then((msg) => {
        if (msg.type === "error") {
          setNotification(msg);
        }
      });
    } else {
      // then user DOES NOT have a wallet
    }
    // We want to ensure that we are storing the UTM parameters for later, even if the user follows links
    // eslint-disable-next-line react-hooks/exhaustive-deps
    CustomizeWeb3Modal(closeModal);
  }, []);

  return (
    
    <BrowserRouter>
      <StyledContainer>
        <Routes>
          <Route exact path="/" element={<Navigate to={"/home"} />} />
          
            <Route exact path="/home" element={<Home />} />
          
          <Route exact path="/about" element={<Navigate to={"/mintnft"} />} />
          <Route exact path="/inventory" element={<Inventory />} />
          <Route exact path="/mintnft" element={<MintNFT />} />
        </Routes>
      </StyledContainer>

      <Notification data={notification} />
    </BrowserRouter>
    
  );
}

const StyledContainer = styled(Box)`
  position: relative;
  min-height: 100vh;
  width: 100vw;
  overflow-x: hidden;
`;

export default App;
